<wiz-hgroup width="100%" height="100%">
  <wiz-hgroup #rendererLabel height="100%" width="100%" verticalAlign="center">
    <wiz-label width="100%" [wizLabel]="getLabel()"></wiz-label>
    <wiz-label [wizLabel]="getRange()" class="smallFont"></wiz-label>
  </wiz-hgroup>
</wiz-hgroup>
